import { Point } from '@printu/geom';
import { extractStyle, setStyles } from 'app/core/graphics/Style';
export const createStyles = (marker) => {
    const { size } = marker;
    const s1 = {
        strokeCap: 'round',
        strokeJoin: 'round',
        strokeColor: '#ffffff',
        strokeWidth: size * 2,
        shadowColor: '#ffffff',
        shadowBlur: 0,
        shadowOffset: new Point(0, 0),
        fillColor: null,
    };
    const s2 = {
        strokeCap: 'round',
        strokeJoin: 'round',
        fillColor: '#ff0000',
        strokeColor: '#ffffff',
        strokeWidth: size,
    };
    return [s1, s2];
};
export const strokeMarkerRenderer = (ctx, style, markerPainter, opts) => {
    const { useStroke } = opts;
    const s1 = extractStyle(Object.assign(Object.assign({}, style), { strokeColor: '#ffffff' }), [
        'strokeCap',
        'strokeJoin',
        'strokeColor',
        'strokeWidth',
        'shadowColor',
        'shadowBlur',
        'shadowOffset',
        'strokeWidth',
    ], {
        strokeCap: 'round',
        strokeJoin: 'round',
        strokeColor: '#ffffff',
        shadowColor: '#ffffff',
        shadowBlur: 0,
        shadowOffset: new Point(0, 0),
        strokeWidth: 4,
    });
    const s2 = extractStyle(style, ['strokeCap', 'strokeJoin', 'strokeColor', 'strokeWidth'], {
        strokeCap: 'round',
        strokeJoin: 'round',
        strokeColor: '#ff0000',
        strokeWidth: 2,
    });
    if (useStroke) {
        ctx.save();
        setStyles(ctx, Object.assign(Object.assign({}, s1), { strokeWidth: style.strokeWidth * 2 }));
        markerPainter(ctx);
        ctx.stroke();
        ctx.restore();
    }
    ctx.save();
    setStyles(ctx, s2);
    markerPainter(ctx);
    ctx.stroke();
    ctx.restore();
};
export const fillMarkerRenderer = (ctx, style, markerPainter, opts) => {
    const { useStroke } = opts;
    const s1 = extractStyle(style, [
        'strokeCap',
        'strokeJoin',
        'strokeColor',
        'strokeWidth',
        'shadowColor',
        'shadowBlur',
        'shadowOffset',
    ], {
        strokeCap: 'round',
        strokeJoin: 'round',
        strokeColor: '#ffffff',
        shadowColor: '#ffffff',
        shadowBlur: 0,
        shadowOffset: new Point(0, 0),
    });
    const s2 = extractStyle(style, ['strokeCap', 'strokeJoin', 'fillColor', 'strokeColor', 'strokeWidth'], {
        strokeCap: 'round',
        strokeJoin: 'round',
        fillColor: '#ff0000',
        strokeColor: '#ffffff',
    });
    // draw blur and fill ones with stroke over it??
    if (useStroke) {
        ctx.save();
        setStyles(ctx, s1);
        markerPainter(ctx);
        ctx.stroke();
        ctx.restore();
        ctx.save();
        setStyles(ctx, s2);
        markerPainter(ctx);
        ctx.stroke();
        ctx.restore();
    }
    ctx.save();
    setStyles(ctx, s2);
    ctx.strokeStyle = null;
    markerPainter(ctx);
    ctx.fill();
    ctx.restore();
};
export const fillTextMarkerRenderer = (ctx, style, strokePainter, fillPainter, opts) => {
    const { useStroke } = opts;
    const s1 = extractStyle(style, [
        'strokeCap',
        'strokeJoin',
        'strokeColor',
        'strokeWidth',
        'shadowColor',
        'shadowBlur',
        'shadowOffset',
    ], {
        strokeCap: 'round',
        strokeJoin: 'round',
        strokeColor: '#ffffff',
        shadowColor: '#ffffff',
        shadowBlur: 4,
        shadowOffset: { x: 0, y: 0 },
    });
    const s2 = extractStyle(style, ['strokeCap', 'strokeJoin', 'fillColor', 'strokeColor'], {
        strokeCap: 'round',
        strokeJoin: 'round',
        fillColor: '#ff0000',
        strokeColor: '#ffffff',
    });
    if (useStroke) {
        // NOTE: on firefox this hits performance
        // ctx.save();
        // setStyles(ctx, s1);
        // fillPainter(ctx);
        // ctx.restore();
        ctx.save();
        setStyles(ctx, s1);
        strokePainter(ctx);
        ctx.restore();
    }
    ctx.save();
    setStyles(ctx, s2);
    ctx.strokeStyle = null;
    fillPainter(ctx);
    ctx.restore();
};
